import { useState } from "react";
import { faqData } from "@/mocks/aboutData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于虚空韩漫网的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-background-200 overflow-hidden transition-all"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                onClick={() => toggle(index)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-6">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}